import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
    ol: {
        fontSize: '12px',
        paddingLeft: '20px',
        '& ol': {
            paddingInlineStart: '20px',
        },
        '& .lower-alpha': {
            listStyleType: 'lower-alpha',
        },
        '& .lower-roman': {
            listStyleType: 'lower-roman',
        },
        '& li': {
            marginBottom: '6px',
        },
    },
    p: {
        fontSize: '14px',
    },
    t524__imgwrapper: {
        width: '150px',
        maxWidth: '100%',
        marginBottom: '20px',
        marginTop: '20px',
        align:'center',

    },
    person_img:{
        maxWidth: '150px',
        borderRadius:'50%',
        align:'center',
    },
    grid: {
        width: 'calc(100% + 8px)',
        margin: '0 -4px',
        '& > .MuiGrid-item': {
            padding: '5px',
        },
    },
    item: {
        paddingTop:'20px',
        padding: '8px',
        align:'center',
    },
    h3:{
        fontSize: '14px',
        padding: '0px',
    },
    h4:{
        fontSize: '12px',
        padding: '0px',
    },


}));

const AboutUs = () => {
    const classes = useStyles();

    return (
        <section
            style={{
                minHeight: 'inherit',
                color: 'black',
                margin: '0 auto',
                padding: '20px',
                maxWidth: '1024px',
                backgroundColor: '#f05b83',

            }}
        >
            <center>
            <img src='/logo.png' alt='logo' width='90px' height='90px' className={classes.logoImg} />
            </center>

            <h1 style={{textAlign: 'center'}}>About Us</h1>
            <main>
                <p className={classes.p}>
                    We are a team of engineers, designers, and operators with experience in
                    building products at companies like NetApp, Yatra, Arvind internet etc.
                    We have combined experience of more than 20 years in retail and ecommerce.
                    We have come together with a common goal of revolutionising automated retail.
                </p>

                <p className={classes.p}>
                    <h1 style={{textAlign: 'center'}}>Meet our team</h1>
                    <p className={classes.p}>
                    The smartest people work every day to provide the best service and to make our clients happy
                    </p>
                </p>

                <Grid
                    container
                    spacing={2}
                    classes={{
                        'spacing-xs-2': classes.grid,
                    }}
                >
                    <Grid item xs={12 / 2} className={classes.item}>
                        <center style={{height: '150px'}}>
                    <img src='/images/aboutus/tild3232-6362-4632-a136-383861613335__person_placeholder.jpg' height='150px' width='150px' className={classes.person_img}
                         style={{vertical: 'center'}}/>
                            <h3 className={classes.h3} style={{textAlign: 'bottom'}}>Barun Kumar Ghadia</h3>
                            <h4 className={classes.h4} style={{textAlign: 'bottom'}}>Proprietor</h4>
                        </center>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild6434-3737-4737-b238-373064316462__Sachin.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Sachin Velaga</h4>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Software Architect</h4>

                    </Grid>

                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild3933-6437-4331-b861-613965643636__Jitesh.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Jitesh Varandani</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Sr. Full Stack Engineer</h4>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild3032-3564-4134-b265-633135633766__Uday.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Udhay</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Product Manager</h4>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild3237-6136-4239-b165-346365373733__Sai.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Saideep Kasam</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Backend Developer</h4>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild6162-6137-4430-b363-363234373165__ramki.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Ramki Ravi</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Backend Developer</h4>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild3763-3366-4339-a666-663432333565__Parth.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Parth Patel</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Embedded systems Engineer</h4>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center >
                            <img src='/images/aboutus/tild3530-6561-4366-b434-346435386362__Vishwa.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Vishwanath</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Embedded systems Engineer</h4>

                    </Grid>
                    <Grid  item xs={12 / 2} className={classes.item}>
                        <center>
                            <img src='/images/aboutus/tild3033-3065-4638-a364-326331376534__Loge.jpeg'  height='150px' width='150px'  className={classes.person_img}
                            />
                        </center>
                        <h3 className={classes.h3} style={{textAlign: 'center'}}>Logeshwaran</h3>
                        <h4 className={classes.h4} style={{textAlign: 'center'}}>Embedded system- Tools & infra</h4>

                    </Grid>
                </Grid>
                <p className={classes.p}>
                    <center>
                    	<a href={'/'}>Home</a> | <a href={'/aboutus'}>About Us</a> | <a href={'/contactus'}>Contact Us</a>  | <a href={'/terms-and-conditions'}>Terms</a> | <a href={'/shipping'}>Shipping</a>
                    </center>
                </p>

            </main>

        </section>
    );
};
export default AboutUs;
